/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */
import styled from 'styled-components';

const CalendarSelectorMonthStyled = styled.div.attrs({
    'data-calendar-select': 'selectorMonth',
})`
    margin-bottom: 0;
`;

const CalendarSelectorYearStyled = styled.div.attrs({
    'className': 'selector-year',
    'data-calendar-select': 'selectorYear',
})`
    margin-bottom: 8px;
`;

export {
    CalendarSelectorMonthStyled,
    CalendarSelectorYearStyled,
};
